import React, { useState } from 'react';
import moment from "moment-timezone";
import { useToast } from "@/components/ui/use-toast";
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import { runReport } from '@/lib/contractMTMReport';
import { downloadBinaryData } from "@/lib/browser/download";

export function ContractMTMReportDashboard() {
  const { toast } = useToast();
  const [isGenerating, setIsGenerating] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setFile(file);
  };

  const handleGenerate = async () => {
    if (isGenerating) { return; }
    if (!file) {
      return;
    }

    setIsGenerating(true);
    try {
      const result = await runReport(file);

      const date = moment().format("YYYY_MM_DDTHHmm");
      downloadBinaryData(
        result.buffer,
        `contract_mtm_report_${date}.xlsx`,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      );

      toast({
        title: "Generated"
      })
    } catch (error) {
      console.error('Error generating contract MTM report:', error);
      toast({
        title: "Failed to generate report"
      })
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="container mx-auto p-6">
      <Card>
        <CardHeader>
          <CardTitle>Contract MTM Report</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="contract-mtm-file">Excel File *</Label>
            <Input
              id="contract-mtm-file"
              type="file"
              accept=".xlsx,.xls"
              onChange={handleFileChange}
              disabled={isGenerating}
            />
          </div>

          <Button
            onClick={handleGenerate}
            disabled={!file || isGenerating}
            className="w-full"
          >
            {isGenerating ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Generating Report...
              </>
            ) : (
              'Generate Report'
            )}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export default ContractMTMReportDashboard;

